// The focus ring is for the keyboard (owner request 03/11/2026). Pages move the focus themselves so a screen reader follows
// (the way back on an exercise or a workout opened as a page, the card that opened it on the way back, a dialog's opener
// when it closes, a slider as it opens), and Safari counts a focus moved by a script as :focus-visible: a tap or a click
// left the ring on a button nobody pressed, on the iPhone and on the Mac. So <html data-input> notes how the person last
// used the page, and the CSS draws the ring only after a key (redesign.css). Tab after a tap shows it at once: the key
// lands before the focus moves.

// Option stays a key: Option+Tab is how Safari reaches buttons and links
const isShortcut = (event) => event.metaKey || event.ctrlKey || ['Meta', 'Control', 'Alt', 'Shift', 'CapsLock'].includes(event.key);

export const installFocusRing = (win = window) => {
  const doc = win.document;
  const note = (input) => {
    if (doc.documentElement.dataset.input !== input) doc.documentElement.dataset.input = input;
  };
  doc.addEventListener('keydown', (event) => !isShortcut(event) && note('keyboard'), true);
  doc.addEventListener('pointerdown', () => note('pointer'), true);
};
